import { L10nContext } from 'context/L10nContext';
import { ModalDialogueHeader } from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-header/ModalDialogueHeader';
import { ModalDialogueSection } from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-section/ModalDialogueSection';
import { ModalDialogue } from 'presentation/ui/compositions/modal-dialogue/ModalDialogue';
import { IconIdentifier } from 'presentation/ui/partials/icon/IconIdentifier';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { selectCreatedGenerator } from 'services/nuclide/store/generatorSlice';
import { AsyncReducerStatus } from 'store/common/AsyncReducerStatus';
import { useTypedSelector } from 'store/common/TypedSelector';
import { GeneratorCreateForm } from '../generator-create-form/GeneratorCreateForm';
import { GeneratorCreateFailedNotification } from './GeneratorCreateFailedNotification';
import { GeneratorCreateSuccessNotification } from './GeneratorCreateSuccessNotification';

interface GeneratorCreateModalProps {
	/**
	 * onDismiss
	 */
	onDismiss: () => void;
}

/**
 * The generator create modal
 */
export const GeneratorCreateModal = (props: GeneratorCreateModalProps): JSX.Element => {
	const { onDismiss } = props;

	// Consume the context
	const l10nContext = useContext(L10nContext);

	// Use selector to provide information from store
	const createdGenerator = useSelector(selectCreatedGenerator());
	const generatorActionStatus = useTypedSelector(state => state.generators.actionStatus);

	const renderModal = () => {
		let modal: JSX.Element = null;

		switch (generatorActionStatus) {
			case AsyncReducerStatus.IDLE:
				modal = <GeneratorCreateForm />;
				break;

			case AsyncReducerStatus.CREATED:
				modal =
					<GeneratorCreateSuccessNotification
						onClickConfirm={onDismiss}
						generatorCreated={createdGenerator}
					/>;
				break;

			case AsyncReducerStatus.FAILED:
				modal = 
					<GeneratorCreateFailedNotification
						onClickConfirm={onDismiss}
					/>;
				break;
		}
		return modal;

	};

	return (
		<ModalDialogue onDismiss={onDismiss}>
			<ModalDialogueHeader
				captionText={l10nContext.translate('view.generators.modal.action.create.caption', 'Generator hinzufügen')}
				captionIcon={IconIdentifier.ADD}
			/>
			<ModalDialogueSection>
				{renderModal()}
			</ModalDialogueSection>
		</ModalDialogue>
	);
};